import React, { useState, useEffect, useRef, memo } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import DeviceAlarmCard from './DeviceAlarmsCard/DeviceAlarmCard';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import Draggable from 'react-draggable';
import { IconLoader } from 'common/IconLoader';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { checkIsCommissioned, deviceToProductTypeDisplayString } from 'common/utils/helpers';
import { isItBundle } from 'common/utils/deviceTwinUtils';

import './DeviceAlarms.css';
import { doFetchAlarms, storeAllDeviceAlarms } from 'redux/actions';
import { deviceTypeToIcon, alarmSeverity, getTrimmedString } from './utils';


let globalDevicesRenderKey = 0;

const useAlarmsCaller = (mounted, renderKey, props, deviceIDs) => {
  const dispatch = useDispatch();
  if (props.devices != null && props.devices.length !== 0 && (!mounted.current || renderKey > globalDevicesRenderKey)) {
    dispatch(
      doFetchAlarms(
        deviceIDs.current, // deviceIDs,
        null,
        null,
        ['active'],
        null,
        null,
        1000,
        null,
        ['severity'],
        (result) => {
          //this.setState({ alarmFetchingErrorCode: null });
          globalDevicesRenderKey = renderKey;
          dispatch(storeAllDeviceAlarms(result));
        },
        (error) => {
          //this.setState({ alarmFetchingErrorCode: error });
        },
        []
      )
    );
  }
};

let fetchAlarmsIntervalID;

const useAlarmsPoller = (props, deviceIDs) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (fetchAlarmsIntervalID) clearInterval(fetchAlarmsIntervalID);
    fetchAlarmsIntervalID = setInterval(() => {
      if (props.devices != null && props.devices.length !== 0) {
        dispatch(
          doFetchAlarms(
            deviceIDs.current, // deviceIDs,
            null,
            null,
            ['active'],
            null,
            null,
            1000,
            null,
            ['severity'],
            (result) => {
              //this.setState({ alarmFetchingErrorCode: null });
              dispatch(storeAllDeviceAlarms(result));
            },
            (error) => {
              //this.setState({ alarmFetchingErrorCode: error });
            },
            []
          )
        );
      }
    }, 15000);
    return () => {
      if (fetchAlarmsIntervalID) clearInterval(fetchAlarmsIntervalID);
    };
  }, []);
};

const DeviceAlarms = (props) => {
  const [dragIconHovered, setDragIconHovered] = useState(false);

  // donor(bundled)/echo/single pivot device id
  const [selectedLeaderDeviceId, setSelectedLeaderDeviceId] = useState('');
  const [selectedLeaderDeviceType, setSelectedLeaderDeviceType] = useState('');
  const [selectedMemberDeviceIds, setSelectedMemberDeviceIds] = useState([]);
  const [selectedMemberDeviceTypes, setSelectedMemberDeviceTypes] = useState([]);
  const [selectedDeviceName, setSelectedDeviceName] = useState('');
  const [highlightedItems, setHighlightedItems] = useState([]);
  const [alarmsRenderKey, setAlarmsRenderKey] = useState(0);
  const [devicesRenderKey, setDevicesRenderKey] = useState(0);

  const allAlarms = useSelector((store) => store?.data?.alarms?.deviceAlarms);
  const selectedListName = useSelector((store) => store?.ui?.devicesPage?.selectedDeviceGroupName);

  const selectedAlarms = useSelector((store) => {
    if (selectedLeaderDeviceId === '') return null;

    let currAlarms = {};
    currAlarms[selectedLeaderDeviceId] = store?.data?.alarms?.deviceAlarms?.[selectedLeaderDeviceId];

    if (selectedMemberDeviceIds.length === 0) return currAlarms;

    selectedMemberDeviceIds.forEach((memberId) => {
      currAlarms[memberId] = store?.data?.alarms?.deviceAlarms?.[memberId];
    });

    return currAlarms;
  });

  const sortAlarmsBy = useSelector((store) => store?.ui?.devicesPage?.sortAlarmsBy);

  useEffect(() => {
    setDevicesRenderKey((key) => key + 1);
  }, [props.devices]);

  useEffect(() => {
    setSelectedLeaderDeviceId('');
  }, [selectedListName]);

  const getDeviceIds = (rawDevicesData) => {
    let flattenedDeviceIds = [];
    rawDevicesData.forEach((rawData) => {
      if (rawData.id) {
        flattenedDeviceIds.push(rawData.id);
      } else if (rawData.members) {
        rawData.members.forEach((member) => {
          flattenedDeviceIds.push(member.deviceId);
        });
      }
    });

    return flattenedDeviceIds;
  };

  const isAlarmsMapped = useRef(false);
  const deviceIDs = useRef(getDeviceIds(props.devices));

  useEffect(() => {
    deviceIDs.current = getDeviceIds(props.devices);
  });

  // useEffect(() => {
  //   if (isAlarmsMapped === false && props.devices) {

  //   }
  // });

  const getAlarmDetails = () => {
    if (selectedLeaderDeviceId === '') return null;

    let currAlarms = selectedAlarms[selectedLeaderDeviceId];
    return (
      <div className="DeviceAlarms_AlarmDetails_Content">
        <PerfectScrollbar>
          {selectedMemberDeviceIds.length === 0 ? getSingleAlarmDetail(currAlarms) : getBundleAlarmDetail()}
        </PerfectScrollbar>
      </div>
    );
  };

  const getSingleAlarmDetail = (currAlarms) => {
    if (!currAlarms || currAlarms.length === 0) {
      return <div className="DeviceAlarms_AlarmDetails_Content_NoAlarmText">No active alarms for this device</div>;
    }
    return currAlarms.map((a, index) => getSingleAlarmMessage(a, index));
  };

  const getBundleAlarmDetail = () => {
    let deviceIds = [];
    let deviceTypes = [];

    if (selectedLeaderDeviceId && selectedLeaderDeviceType) {
      deviceIds.push(selectedLeaderDeviceId);
      deviceTypes.push(selectedLeaderDeviceType);
    }

    if (selectedMemberDeviceIds && selectedMemberDeviceTypes) {
      selectedMemberDeviceIds.forEach((id) => deviceIds.push(id));
      selectedMemberDeviceTypes.forEach((type) => deviceTypes.push(type));
    }

    return (
      <div>
        {deviceIds.map((deviceId, index) => (
          <div className="DeviceAlarms_AlarmDetails_Content_BundleWrapper">
            <div className="DeviceAlarms_AlarmDetails_Content_Subheader">
              <div className="DeviceAlarms_AlarmDetails_Content_Subheader_Icon">
                <img src={deviceTypeToIcon[deviceTypes[index]] || IconLoader.icon_donor} alt="" />
              </div>
              <div className="DeviceAlarms_AlarmDetails_Content_Subheader_Id">{deviceId}</div>
            </div>
            {selectedAlarms[deviceId] && selectedAlarms[deviceId].map((a, i) => getSingleAlarmMessage(a, i))}
            {!selectedAlarms[deviceId] && (
              <div className="DeviceAlarms_AlarmDetails_Content_NoAlarmText">No active alarms for this device</div>
            )}
          </div>
        ))}
      </div>
    );
  };

  const getSingleAlarmMessage = (alarm, index) => {
    let currIcon = null;
    switch (alarm.severity) {
      case 'CRITICAL':
        currIcon = IconLoader.icon_alarm_critical;
        break;
      case 'MAJOR':
        currIcon = IconLoader.icon_alarm_major;
        break;
      case 'MINOR':
        currIcon = IconLoader.icon_alarm_minor;
        break;
      case 'WARNING':
        currIcon = IconLoader.icon_alarm_warning;
        break;
      case 'INFO':
        currIcon = IconLoader.icon_alarm_info;
        break;
      default:
        currIcon = IconLoader.icon_alarm_unknown_num;
        break;
    }

    return (
      <div className="DeviceAlarms_AlarmDetails_Content_SingleAlarm" key={index}>
        <div className="DeviceAlarms_AlarmDetails_Content_SingleAlarm_Icon">
          <SvgAF img={currIcon} scaleImg={true} tooltip={alarm.severity} />
        </div>
        <div className="DeviceAlarms_AlarmDetails_Content_SingleAlarm_Text">{getTrimmedString(alarm.name, 35)}</div>
      </div>
    );
  };



  const getLeaderDeviceType = (device) => {
    if (!device) return 'Unknown';

    const types = device.members.map((member) => deviceToProductTypeDisplayString(member));

    return types.includes('Pivot 5G Donor') ? 'Pivot 5G Donor' : 'Pivot 5G Service';
  };

  const getLeaderDeviceId = (device) => {
    if (!device || !device.members) return '';

    let donorDevice = device.members.find((member) => member?.tags?.bundle?.name && member?.tags?.bundle?.type);
    if (!donorDevice) {
      return device.members[0].deviceId;
    }

    return donorDevice.deviceId;
  };

  const getAlarmCounts = (device, isBundle) => {
    let alarmCounts = [0, 0, 0, 0, 0, 0];
    if (!allAlarms) return alarmCounts;

    let deviceIds = isBundle ? device.members.map((currDevice) => currDevice.deviceId) : [device.id];

    deviceIds.forEach((id) => {
      const currActiveAlarms = allAlarms[id];

      if (currActiveAlarms) {
        currActiveAlarms.forEach((alarm) => {
          let alarmTypeIndex = alarmSeverity[alarm.severity];
          if (alarmTypeIndex === undefined) {
            // aggregate to UNKNOWN for severities other than 5 major types
            alarmCounts[alarmSeverity.UNKNOWN] += 1;
          } else {
            alarmCounts[alarmTypeIndex] += 1;
          }
        });
      }
    });

    return alarmCounts;
  };

  const onAlarmSelect = (currDevice, deviceId, displayName) => {
    if (selectedLeaderDeviceId === deviceId) {
      setSelectedLeaderDeviceId('');
      setSelectedLeaderDeviceType('');
      setSelectedMemberDeviceIds([]);
      setSelectedMemberDeviceTypes([]);
      setSelectedDeviceName('');
    } else {
      setSelectedLeaderDeviceId(deviceId);
      setSelectedDeviceName(displayName);
      if (!isItBundle(currDevice)) {
        const leaderDeviceType = deviceToProductTypeDisplayString(currDevice);
        setSelectedLeaderDeviceType(leaderDeviceType);
        setSelectedMemberDeviceIds([]);
        setSelectedMemberDeviceTypes([]);
        return;
      }

      setSelectedLeaderDeviceType(getLeaderDeviceType(currDevice));

      let memberDeviceIds = [];
      let memberDeviceTypes = [];
      currDevice.members.forEach((member) => {
        if (member.deviceId !== deviceId) {
          memberDeviceIds.push(member.deviceId);
          memberDeviceTypes.push(deviceToProductTypeDisplayString(member));
        }
      });

      setSelectedMemberDeviceIds(memberDeviceIds);
      setSelectedMemberDeviceTypes(memberDeviceTypes);
    }
  };

  const onHightlight = (deviceId) => {
    const highlightedItemsCopy = [...highlightedItems];
    const index = highlightedItemsCopy.indexOf(deviceId);

    if (index > -1) {
      highlightedItemsCopy.splice(index, 1);
    } else {
      highlightedItemsCopy.push(deviceId);
    }

    setHighlightedItems(highlightedItemsCopy);
  };

  const getEmptyDevices = () => {
    const NUM_OF_EMPTY_CARDS = 50;
    let devices = [];
    for (let i = 0; i < NUM_OF_EMPTY_CARDS; i++) {
      devices.push(i);
    }

    return devices;
  };

  const getSortedDevices = () => {
    if (!sortAlarmsBy || sortAlarmsBy === '') return props.devices;

    const devicesCopy = JSON.parse(JSON.stringify(props.devices));
    if (sortAlarmsBy === 'Severity') {
      // sort by number of alarms DESC
      devicesCopy.sort((a, b) => {
        const listA = getAlarmCounts(a, isItBundle(a));
        const listB = getAlarmCounts(b, isItBundle(b));
        const sumA = listA.reduce((x, y) => x + y);
        const sumB = listB.reduce((x, y) => x + y);

        return sumB - sumA;
      });

      return devicesCopy;
    } else if (sortAlarmsBy === 'Device ID/Name') {
      devicesCopy.sort((a, b) => {
        const displayNameA = isItBundle(a) ? getLeaderDeviceId(a) : a.deviceId;
        const displayNameB = isItBundle(b) ? getLeaderDeviceId(b) : b.deviceId;

        return displayNameA.attr > displayNameB.attr ? 1 : -1;
      });
    }

    return props.devices;
  };

  const mounted = useRef();
  useEffect(() => {
    if (!mounted.current) {
      // do componentDidMount logic
      mounted.current = true;
    } else {
      // do componentDidUpdate logic
    }
  });

  useAlarmsCaller(mounted, devicesRenderKey, props, deviceIDs);

  useAlarmsPoller(props, deviceIDs);

  return (
    <div className="DeviceAlarmsContainer">
      <PerfectScrollbar>
        <div className="DeviceAlarms_Grid">
          {!selectedListName
            ? getEmptyDevices().map((i) => <DeviceAlarmCard key={i} isEmpty={true} />)
            : getSortedDevices().map((device, index) => {
                const isBundle = isItBundle(device);
                const displayName = isBundle ? device.name : device.tags?.userLabel || device.deviceId;
                const deviceId = isBundle ? getLeaderDeviceId(device) : device.deviceId;
                const deviceType = isBundle ? getLeaderDeviceType(device) : deviceToProductTypeDisplayString(device);
                const connectionState = device.connectionState || 'Unknown';
                const isCommissioned = checkIsCommissioned(device, isBundle);
                const adminState = device.properties?.reported?.adminState || 'Unknown';
                const isSelected = selectedLeaderDeviceId === deviceId;

                return (
                  <DeviceAlarmCard
                    key={index}
                    index={index}
                    alarmCounts={getAlarmCounts(device, isBundle)}
                    device={device}
                    displayName={displayName}
                    deviceId={deviceId}
                    deviceType={deviceType}
                    connectionState={connectionState}
                    isCommissioned={isCommissioned}
                    adminState={adminState}
                    isSelected={isSelected}
                    onSelect={(currDevice, deviceId, displayName) => onAlarmSelect(currDevice, deviceId, displayName)}
                    onHighlight={(deviceId) => onHightlight(deviceId)}
                    isHighlighted={highlightedItems.indexOf(deviceId) > -1}
                  />
                );
              })}
        </div>
      </PerfectScrollbar>
      {selectedLeaderDeviceId !== '' && (
        <Draggable handle=".DeviceAlarms_AlarmDetails_Header_DragIcon">
          <div className="DeviceAlarms_AlarmDetails">
            <div className="DeviceAlarms_AlarmDetails_Header">
              <div
                className="DeviceAlarms_AlarmDetails_Header_DragIcon"
                draggable={true}
                data-tip="Drag"
                onDragStart={(event) => event.preventDefault()}
                onMouseEnter={() => {
                  setDragIconHovered(true);
                }}
                onMouseLeave={() => {
                  setDragIconHovered(false);
                }}
              >
                <img src={dragIconHovered ? IconLoader.icon_handle_hover_drag : IconLoader.icon_handle} alt={''} />
              </div>
              <div className="DeviceAlarms_AlarmDetails_Header_Text">Alarm details for</div>
              <Link
                className="DeviceAlarms_AlarmDetails_Header_DeviceId"
                to={'/console/devices/detail?' + selectedLeaderDeviceId}
                data-tip="See device details"
              >
                {getTrimmedString(selectedDeviceName, 30)}
              </Link>
              <div className="DeviceAlarms_AlarmDetails_Header_CloseX" onClick={() => setSelectedLeaderDeviceId('')}>
                <SvgAF img={IconLoader.icon_close_window_mid} hover={IconLoader.icon_close_window_mid_hover} />
              </div>
            </div>
            {getAlarmDetails()}
          </div>
        </Draggable>
      )}
    </div>
  );
};

export default memo(DeviceAlarms);
